import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a2197176"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "changePassword" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  style: {"font-size":"16px","font-weight":"bold","color":"#00a2e9","margin-left":"18%"}
}
const _hoisted_5 = { style: {"display":"flex","flex":"1"} }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  style: {"font-size":"16px","font-weight":"bold","color":"#00a2e9","margin-left":"200px"}
}
const _hoisted_9 = { style: {"display":"flex","flex":"1"} }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "dialog-footer" }

import { ref, getCurrentInstance, reactive, onMounted } from 'vue'
import { FormRules, ElForm, ElMessage } from 'element-plus'
import { getMeInfo, getAuthentication } from '@/api/myProfile'
interface EmitType {
    (e: 'onchange', params: boolean): void
  }

export default /*#__PURE__*/_defineComponent({
  __name: 'changePassword',
  props: {
  changepwd: { type: Boolean, default: false }
},
  emits: ["onchange"],
  setup(__props, { emit }: { emit: ({
    (e: 'onchange', params: boolean): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props

const changePass = ref<InstanceType<typeof ElForm>>()
const islogin = ref<boolean>(false)
const { proxy } = getCurrentInstance() as any

const form = reactive({
  verify_type: '1',
  code: '',
  password: '',
  password_confirmation: '',
  mobile: '',
  email: ''
})
// 打开对话框

const { t } = getCurrentInstance()?.appContext.config.globalProperties.$i18n
const rules = reactive<FormRules>({
  // oldpassword: [{
  //   required: true,
  //   validator: (rule, value, callback) => {
  //     if (!value) {
  //       callback(new Error(t('setting.oldPWError')))
  //     } else {
  //       callback()
  //     }
  //   },
  //   trigger: 'blur'
  // }],
  code: { required: true, message: t('setting.PLinput'), trigger: 'blur' },
  password: [{
    required: true,
    validator: (rule, value, callback) => {
      if (!value) {
        callback(new Error(t('setting.PWError')))
      } else {
        callback()
      }
    },
    trigger: 'blur'
  }, {
    validator: (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error(t('login.PWnum')))
      } else {
        callback()
      }
    }
  }],
  password_confirmation: [
    {
      required: true,
      validator: (rule, value, callback) => {
        if (!value) {
          callback(new Error(t('setting.PWErrors')))
        } else {
          callback()
        }
      },
      trigger: 'blur'
    },
    {
      validator: (rule, value, callback) => {
        if (value !== form.password) {
          callback(new Error(t('setting.inconsistent')))
        } else {
          callback()
        }
      }
    }, {
      validator: (rule, value, callback) => {
        if (value.length < 6) {
          callback(new Error(t('login.PWnum')))
        } else {
          callback()
        }
      }
    }
  ]
})

  

const cancel = () => {
  changePass.value?.resetFields()
  emit('onchange', false)
}
const confirm = async () => {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const validate = await proxy.$refs.changePass.validate().catch(() => {})
  if (!validate) {
    return false
  }
  if (!isCode.value) {
    proxy.$message.warning(t('setting.firstgetCode'))
    return
  }
  islogin.value = true
  // const oldencryptPass = proxy.$TOOL.crypot.AES.encrypt(
  //   form.oldpassword,
  //   proxy.$CONFIG.LS_ENCRYPTION_key
  // )
  const encryptPass = proxy.$TOOL.crypot.AES.encrypt(
    form.password,
    proxy.$CONFIG.LS_ENCRYPTION_key
  )
  const encryptPassagain = proxy.$TOOL.crypot.AES.encrypt(
    form.password_confirmation,
    proxy.$CONFIG.LS_ENCRYPTION_key
  )
  const data = {
    // old_password: oldencryptPass,
    password: encryptPass,
    password_confirmation: encryptPassagain,
    verify_type: getcode.verify_type,
    code: form.code,
    mobile: form.mobile,
    email: form.email
  }
  proxy.$API.resetPassword(data).then((res: any) => {
    islogin.value = false
    if (res.code === 200) {
      proxy.$message.success(t('setting.Modificationsuccess'))
      emit('onchange', false)
      changePass.value?.resetFields()
    } else {
      // emit('onchange', false)
      changePass.value?.resetFields()
    }
  }).catch(() => {
    islogin.value = false
  })
}
const close = () => {
  islogin.value = false
  changePass.value?.resetFields()
  Type.value = '1'
  form.verify_type = '1'
  item.value = false
  isCode.value = false
  Time.value = 0
  emit('onchange', false)
}
// **********************************新修改密码*******************
const TypeList = ref({
  1: t('setting.tel'),
  2: t('setting.emailbox')
  // 3: '人脸识别验证'
})
const Type = ref('1')

const getcodeFn = (type: any) => {
  Type.value = type
  getcode.verify_type = type
  form.code = ''
  item.value = false
  Time.value = 0
  isCode.value = false
  // getAuthenticationFn()
}
// 获取验证码
const isCode = ref(false)
const getcode = reactive({
  verify_type: '1',
  mobile: '',
  email: '',
  mobile_zone: ''
})
const item = ref(false)
const getAuthenticationFn = () => {
  getAuthentication(getcode).then((res:any) => {
    if (res.code === 200) {
      isCode.value = true
      item.value = true
      Timefn()
      // ElMessage.success(res.msg)
      ElMessage.success(t('setting.hasCode'))
    } else {
      ElMessage.error(res.msg)
    }
  })
}
onMounted(() => {
  getMeInfo().then((res) => {
    if (res.code === 200) {
      getcode.email = res.data.email
      getcode.mobile = res.data.mobile
      getcode.mobile_zone = res.data.mobile_zone
      form.email = res.data.email
      form.mobile = res.data.mobile
    }
  })
})
// 倒计时
const Time = ref(0)
const Timefn = () => {
  Time.value = 60
  const t = setInterval(() => {
    // Btndisabled.value = true
    Time.value -= 1
    if (Time.value < 1) {
      clearInterval(t)
      // Btndisabled.value = false
      Time.value = 0
      clearInterval(t)
    }
  }, 1000)
}

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: props.changepwd,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((props.changepwd) = $event)),
      title: _ctx.$t('setting.changePassword'),
      width: "40%",
      "min-width": "600px",
      "align-center": "",
      onClose: close
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_11, [
          _createVNode(_component_el_button, { onClick: cancel }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.Cancel')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: confirm,
            loading: islogin.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.Confirm')), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(ElForm), {
          ref_key: "changePass",
          ref: changePass,
          model: form,
          rules: rules,
          "label-width": "210px",
          size: "large",
          "label-position": "right"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _unref(t)('setting.PLresetWay'),
              prop: "verify_type"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: form.verify_type,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.verify_type) = $event)),
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (getcodeFn(form.verify_type)))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(TypeList.value, (key, obj, i) => {
                      return (_openBlock(), _createBlock(_component_el_radio, {
                        key: i,
                        label: obj
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(key), 1)
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            (form.verify_type)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (Number(Type.value) === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(_component_el_form_item, {
                          label: _unref(t)('setting.phone'),
                          prop: "mobile"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: form.mobile,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.mobile) = $event)),
                              class: "form_input",
                              disabled: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        (item.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(t)('setting.hastelCode')), 1))
                          : _createCommentVNode("", true),
                        _createVNode(_component_el_form_item, {
                          label: _unref(t)('setting.telCode'),
                          prop: "code",
                          required: ""
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_5, [
                              _createVNode(_component_el_input, {
                                modelValue: form.code,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.code) = $event)),
                                class: "form_input",
                                width: "100%"
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_el_button, {
                                type: "primary",
                                onClick: getAuthenticationFn
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('setting.getCode')), 1),
                                  (Time.value!==0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, "(" + _toDisplayString(Time.value) + ")", 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]))
                    : _createCommentVNode("", true),
                  (Number(Type.value) === 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(_component_el_form_item, {
                          label: _unref(t)('setting.email'),
                          prop: "email"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: form.email,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.email) = $event)),
                              class: "form_input",
                              disabled: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        (item.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_unref(t)('setting.hasemailCode')), 1))
                          : _createCommentVNode("", true),
                        _createVNode(_component_el_form_item, {
                          label: _unref(t)('setting.emailCode'),
                          prop: "code",
                          required: ""
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_9, [
                              _createVNode(_component_el_input, {
                                modelValue: form.code,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.code) = $event)),
                                class: "form_input",
                                width: "100%"
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_el_button, {
                                type: "primary",
                                onClick: getAuthenticationFn
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('setting.getCode')), 1),
                                  (Time.value!==0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, "(" + _toDisplayString(Time.value) + ")", 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_form_item, {
                    prop: "password",
                    label: _ctx.$t('setting.Password')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: form.password,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.password) = $event)),
                        clearable: "",
                        "show-password": "",
                        placeholder: _ctx.$t('setting.PWPlaceholder'),
                        autocomplete: "new-password"
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    prop: "password_confirmation",
                    label: _ctx.$t('setting.Passwords')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: form.password_confirmation,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.password_confirmation) = $event)),
                        clearable: "",
                        "show-password": "",
                        placeholder: _ctx.$t('setting.PWPlaceholders')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})